






































































import { defineComponent } from '@vue/composition-api';
import GroupsMixin from '@/features/core/components/mixins/groups';
import Panel from '@/features/ui/panel/Panel.global.vue';
import Cell from '@/features/ui/layout/Cell.global.vue';
import Flex from '@/features/ui/layout/Flex.global.vue';
import TableSkeleton from '@/features/ui/table/TableSkeleton.global.vue';
import TextInput from '@/features/ui/inputs/InputText.global.vue';
import ControlTypeList from '@/features/app-heating-system/views/control-values/components/ControlModelList.vue';
import WizardButton from '@/components/clickables/WizardButton.global.vue';
import HeatingSystemRegisterList from '@/features/app-heating-system/views/control-values/components/HeatingSystemRegisterList.vue';
import ClusterList from '@/features/app-heating-system/views/control-values/components/ClusterList.vue';
import RegisterValues from '@/features/app-heating-system/views/control-values/components/RegisterValues.vue';
import RegisterValueCopyModal from '@/features/app-heating-system/views/control-values/components/RegisterValueCopyModal.vue';
import { APOLLO_CLIENT } from '@/features/core/container/model';
import { ApolloQueryResult } from 'apollo-client';
import modbusMappingsQuery from '@/features/app-heating-system/views/tree-node/get-modbus-mappings-cust-id.gql';
import {
  ModbusMappings,
  ModbusMappings_modbusMappingConfig,
  ModbusMappingsVariables,
} from '../tree-node/__generated__/ModbusMappings';
import { mapGetters } from 'vuex';
import heatingControlSpotsQuery from '@/features/app-heating-system/views/control-values/graphql/heatingControlSpots.gql';
import {
  GetHeatingControlDevices,
  GetHeatingControlDevices_spots_items,
  GetHeatingControlDevicesVariables,
} from './graphql/__generated__/GetHeatingControlDevices';

export default defineComponent<any, Record<string, unknown>, any, any>({
  name: 'EditRegistersView',
  components: {
    RegisterValueCopyModal,
    ControlTypeList,
    ClusterList,
    WizardButton,
    Panel,
    Cell,
    Flex,
    TableSkeleton,
    // InputSelect,
    TextInput,
    HeatingSystemRegisterList,
    RegisterValues,
  },
  mixins: [GroupsMixin],
  props: {
    treeNodeId: {
      type: String,
      required: true,
    },
  },
  apollo: {
    modbusMappingsTable: {
      query: modbusMappingsQuery,
      client: APOLLO_CLIENT.PORTAL_CLIENT,
      fetchPolicy: 'no-cache',
      variables(): ModbusMappingsVariables {
        return {
          customerId: this.treeNodeId,
        };
      },
      async result({ data }: ApolloQueryResult<ModbusMappings>): Promise<void> {
        // Set the variable in the store
        this.modbusMappingRules = data.modbusMappingConfig;
        const modelNames = this.modbusMappingRules
          .map((item: ModbusMappings_modbusMappingConfig) => {
            return { name: item.model };
          })
          .sort((a: { name: string }, b: { name: string }) => a.name.localeCompare(b.name));
        this.$store.commit(
          'setControlModelNames',
          modelNames.map((item: { name: string }) => item.name),
        );
      },
    },
    heatingControlDataSpots: {
      query: heatingControlSpotsQuery,
      client: APOLLO_CLIENT.PORTAL_CLIENT,
      fetchPolicy: 'no-cache',
      variables(): GetHeatingControlDevicesVariables {
        return {
          customerId: this.treeNodeId,
        };
      },
      async result({ data }: ApolloQueryResult<GetHeatingControlDevices>): Promise<void> {
        this.heatingControlSpots = data.spots.items.sort((a, b) => {
          const aName = a.property && a.property.node ? a.property.node.name : '';
          const bName = b.property && b.property.node ? b.property.node.name : '';
          return aName.localeCompare(bName);
        });
        await this.$store.dispatch('setHeatingControlDevicesAction', this.heatingControlSpots);
      },
    },
  },
  data() {
    return {
      search: '',
      statusFilter: '',
      modbusMappingRules: null,
      filteredHeatingSystemsData: [],
      searchTxt: '',
      heatingControlSpots: [] as GetHeatingControlDevices_spots_items[],
    };
  },
  computed: {
    ...mapGetters(['canSaveRegisters']),
    heatingControlSpotIds(): string[] {
      return this.heatingControlSpots.map((item: GetHeatingControlDevices_spots_items) => {
        return item.id;
      });
    },
    loading() {
      return false;
    },
  },
  watch: {},
  async mounted() {
    await this.$store.dispatch('loadClusterTableConfig', {
      customerId: this.treeNodeId,
      apolloClient: this.$apollo,
    });
  },
  methods: {
    onSearchUpdate(value: string) {
      if (typeof value === 'string' && value) {
        this.searchTxt = value;
      }
      if (value === '') {
        this.searchTxt = '';
      }
    },
    async saveRegisterValues() {
      this.$store.dispatch('saveHSRegisterValues', {
        apolloClient: this.$apollo,
        finalSave: true,
        customerId: this.treeNodeId,
      });
    },
    onBackClick() {
      this.$store.commit('resetActiveHeatingSystem');
      this.$router.push({
        name: 'AppHeatingSystem/AdvancedView',
        params: { treeNodeId: this.treeNodeId },
      });
    },
  },
});
